import {all, call, fork, put, takeEvery, debounce} from 'bukku/shared/SagaService';
import actions from './actions';
// import { message } from 'antd';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

const successKeys = [
    actions.FORM_DESIGN_CREATE_SUCCESS,
    actions.FORM_DESIGN_READ_SUCCESS,
    actions.FORM_DESIGN_READ_ALL_SUCCESS,
    actions.FORM_DESIGN_UPDATE_SUCCESS,
    actions.FORM_DESIGN_DELETE_SUCCESS,
];
const errorKeys = [
    actions.FORM_DESIGN_CREATE_ERROR,
    actions.FORM_DESIGN_READ_ERROR,
    actions.FORM_DESIGN_READ_ALL_ERROR,
    actions.FORM_DESIGN_UPDATE_ERROR,
    actions.FORM_DESIGN_DELETE_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.FORM_DESIGN_CREATE_SUCCESS:
            return t`The form design is created.`;
        case actions.FORM_DESIGN_UPDATE_SUCCESS:
            return t`The form design is updated.`;
        case actions.FORM_DESIGN_DELETE_SUCCESS:
            return t`The form design is deleted.`;
        default:
            return null;
    }
};

// Create FORM_DESIGN
function* createFormDesignRequest() {
    yield takeEvery(actions.FORM_DESIGN_CREATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({request}) {
                const response = yield call(post, '/form_designs', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.FORM_DESIGN_CREATE_SUCCESS,
                    formDesign: data.form_design,
                });
            });
    });
}

// Read FORM_DESIGN list
function* readFormDesignsRequest() {
    yield takeEvery(actions.FORM_DESIGN_READ_ALL_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({request}) {
                const response = yield call(get, '/form_designs', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.FORM_DESIGN_READ_ALL_SUCCESS,
                    formDesigns: data.form_designs,
                    pagination: data.paging,
                });
            });
    });
}

// Read FORM_DESIGN (by id)
function* readFormDesignRequest() {
    yield takeEvery(actions.FORM_DESIGN_READ_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/form_designs/${id}`, null, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.FORM_DESIGN_READ_SUCCESS,
                    formDesign: data.form_design,
                });
            });
    });
}

// Update FORM_DESIGN (by id)
function* updateFormDesignRequest() {
    yield takeEvery(actions.FORM_DESIGN_UPDATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                const response = yield call(puto, `/form_designs/${id}`, request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.FORM_DESIGN_UPDATE_SUCCESS,
                    formDesign: data.formDesign,
                });
            });
    });
}

// Archive FORM_DESIGN (by id)
function* deleteFormDesignRequest() {
    yield takeEvery(actions.FORM_DESIGN_DELETE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/form_designs/${id}`, null, context);
                yield put({ type: actions.FORM_DESIGN_DELETE_SUCCESS });
            });
    });
}

function* previewFormDesignRequest() {
    yield debounce(500, actions.FORM_DESIGN_PREVIEW_REQUEST, function* ({ request }) {
        try {
            const response = yield call(post, '/form_designs/preview', request);
            const data = yield response.data;

            // On Success
            yield put({
                type: actions.FORM_DESIGN_PREVIEW_SUCCESS,
                formDesignPreview: data,
            });
        }
        catch (error) {
            console.error('qq error', error);
            yield put({
                type: actions.FORM_DESIGN_PREVIEW_ERROR,
            });

            // temporarily comment this out, to prevent antd message.error not working in errorSagaFn
            // message.error(error);
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(createFormDesignRequest),
        fork(readFormDesignsRequest),
        fork(readFormDesignRequest),
        fork(updateFormDesignRequest),
        fork(deleteFormDesignRequest),
        fork(previewFormDesignRequest),
    ]);
}
